import React from 'react'
import stylesheet from "./input.module.css"

function Input(props) {
    return <input className={`w-100 ${stylesheet.input}`} type={props.type} placeholder={props.placeholder} onChange={(e)=>{props.func(e.target.value)}}/>
}

export default Input